module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uk-form"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedValue),
      expression: "selectedValue"
    }],
    attrs: {
      "type": "text",
      "name": _vm.name,
      "data-uk-dropdown": ""
    },
    domProps: {
      "value": _vm._s(_vm.selectedValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.selectedValue = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "uk-dropdown uk-dropdown-small"
  }, [_c('ul', {
    staticClass: "uk-nav uk-nav-dropdown"
  }, _vm._l((_vm.items), function(item) {
    return _c('li', {
      on: {
        "click": function($event) {
          _vm.selectItem(item)
        }
      }
    }, [_vm._v(_vm._s(item[_vm.textField]))])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0df0d619!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UkItemPicker.vue
// module id = 277
// module chunks = 2